import { config } from "../config";

export const baseUrl = config.base_url;

export const EndPoints = {
  apply: baseUrl + "/users/apply",
  validateUser: baseUrl + "/users/apply/validate-info",
  emailExists: baseUrl + "/users/apply/validate-email",
  login: baseUrl + "/users/login",
  forgotPassword: baseUrl + "/users/forgot-password",
  resetPassword: baseUrl + "/users/reset-password",
  changePassword: baseUrl + "/users/change-password",
  contactSupport: baseUrl + "/others/contact-support",
  supportTalent: baseUrl + "/others/support-talent",
  getTechQuestion: baseUrl + "/users/technical-test?year=2022",
  submitLinks: baseUrl + "/users/technical-test",
  sponsor: baseUrl + "/others/support-talent",
  main: baseUrl + "/others/main-app",
  quiz: baseUrl + "/quiz",
};
